window.imagesLoaded = require("imagesloaded");
/**
 * Below function is needed for Backstopjs to do proper regression tests
 * We have to make sure the whole page is loaded and we do also do a check if all the imgs are loaded as well with the external script imagesLoaded
 */

// Alternative to load event
document.onreadystatechange = () => {
    if (document.readyState === 'complete') {

        // and also check if all the images AND backgroundimages have been loaded in the body
        imagesLoaded('body', { background: true }, function() {
            document.body.classList.add('is-fully-rendered');
        });
    }
}